<template>
    <HeaderView />

    <div class="container-fluid">

        <BannerView v-if="showBanner" />

        <div class="header-image image-5"></div>

        <div class="container mt-5">

            <div class="row">
                <div class="mission-container">
                    <p class="caption">Verduurzaming</p>
                    <p>
                        Verduurzaming van de woningvoorraad is één van de grootste opgaven waar LeefGoed voor staat.
                    Onze huurders verdienen woningen die comfortabel, energiezuinig en toekomstbestendig zijn.
                    Tegelijkertijd zijn de beschikbare middelen begrensd en vragen technische en politieke
                    keuzes om zorgvuldige afweging.
                    </p>
                    <!-- <p>
                        <img src="@/assets/infographic_2.png" style="border-radius: 6px; box-shadow: 0 5px 20px rgba(0,0,0,0.2);"/>
                    </p> -->
                </div>
            </div>
            <div class="row">
                <div class="news-container">
                    <!-- <p class="caption">Duurzaam</p> -->
                    <h2>Lagere woonlasten voor huurders</h2>
                    <p>Energiearmoede is een reëel probleem voor een deel van onze huurders. Door woningen beter
                        te isoleren en te voorzien van duurzame installaties, dragen wij bij aan lagere
                        energierekeningen. Dat maakt betaalbaar wonen ook op de langere termijn mogelijk – voor
                        huurders die dat het hardst nodig hebben.</p>
                    <h2>Stapsgewijze aanpak</h2>
                    <p>Wij verduurzamen onze woningvoorraad stap voor stap, op basis van een meerjarenplan.
                        Daarin prioriteren wij woningen met de slechtste energieprestaties en buurten waar
                        de opgave het grootst is. Tegelijk kijken wij altijd naar de samenhang met onderhoud
                        en eventuele renovatie of vervangende nieuwbouw.</p>
                    <!-- <h2>Technische keuzes met langetermijngevolgen</h2>
                    <p>De keuze voor een bepaalde verwarmingstechnologie – zoals isolatie, warmtepompen of
                        aansluiting op een warmtenet – heeft grote gevolgen voor huurders en voor de
                        financiële haalbaarheid van projecten. Wij maken die keuzes weloverwogen, in
                        overleg met gemeenten en andere betrokkenen, en met oog voor wat technisch en
                        organisatorisch uitvoerbaar is.</p> -->
                    <h2>Samenwerking en afhankelijkheden</h2>
                    <p>Verduurzaming is geen werk dat wij alleen doen. Wij zijn afhankelijk van gemeentelijk
                        beleid, netbeheerders, aannemers en leveranciers. Die afhankelijkheden vragen om
                        goed partnerschap en een realistische planning. Wij communiceren open over wat wel
                        en niet haalbaar is, en wanneer.</p>
                    <!-- <h2>Duurzaamheid en nieuwbouw</h2>
                    <p>Nieuwbouw biedt de kans om direct te bouwen naar de hoogste duurzaamheidsstandaard.
                        Wij streven ernaar dat alle nieuwe woningen energieneutraal of aardgasvrij worden
                        opgeleverd. Bij hergebruik van bestaand vastgoed zoeken wij naar de meest
                        effectieve combinatie van ingrepen die passen binnen het beschikbare budget.</p> -->
                </div>
                <!-- <p>
                    Verduurzaming is voor LeefGoed geen doel op zich, maar een middel om onze huurders nu
                    en in de toekomst goed te kunnen huisvesten. Betaalbaar, comfortabel en verantwoord.
                </p> -->
            </div>
            <div class="row">
                <a href="/" class="admin-button small mb-4">
                    <svg viewBox="0 0 32 32" x="0" y="0" width="32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Icon_7"
                            d="M13.97245,22.54195c0.5009,0.601 1.3942,0.682 1.9953,0.181c0.601,-0.501 0.6822,-1.394 0.1813,-1.995zM10.36515,15.99995l-1.0884,-0.907c-0.4378,0.525 -0.4378,1.289 0,1.814zM16.14905,11.27195c0.5009,-0.601 0.4197,-1.494 -0.1813,-1.995c-0.6011,-0.501 -1.4944,-0.42 -1.9953,0.181zM21.63475,17.41695c0.7824,0 1.4166,-0.635 1.4166,-1.417c0,-0.782 -0.6342,-1.417 -1.4166,-1.417zM16.14905,20.72795l-4.6956,-5.635l-2.1767,1.814l4.6957,5.635zM11.45345,16.90695l4.6956,-5.635l-2.1766,-1.814l-4.6957,5.635zM10.36515,17.41695h11.2696v-2.834h-11.2696zM7.98605,7.98595c4.426,-4.426 11.6018,-4.426 16.0278,0l2.0034,-2.003c-5.5324,-5.533 -14.5022,-5.533 -20.0346,0zM24.01385,7.98595c4.4259,4.426 4.4259,11.602 0,16.028l2.0034,2.003c5.5327,-5.532 5.5327,-14.502 0,-20.034zM24.01385,24.01395c-4.426,4.426 -11.6018,4.426 -16.0278,0l-2.0034,2.003c5.5324,5.533 14.5022,5.533 20.0346,0zM7.98605,24.01395c-4.4259,-4.426 -4.4259,-11.602 0,-16.028l-2.0034,-2.003c-5.5325,5.532 -5.5325,14.502 0,20.034z"
                            fill="#000000" xmlns="http://www.w3.org/2000/svg" />
                    </svg>
                    &nbsp;&nbsp;Terug
                </a>
            </div>
        </div>

        <!-- <div class="header-image image-4" style="margin-top:3rem;"></div> -->
    </div>

    <FooterView />
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import BannerView from '@/components/BannerView.vue';
import FooterView from '@/components/FooterView.vue';

export default {
    name: 'InfoVerduurzaming',
    components: {
        HeaderView, BannerView, FooterView
    }
};
</script>

<style scoped>
.container-fluid {
    margin-bottom: 3em;
}

.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    padding-bottom: 1.3125rem;
    background: white;
}

.header-image {
    width: 100%;
    height: 11em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.image-1 {
    background-image: url(@/assets/carousel_2.jpg);
}

.image-2 {
    background-image: url(@/assets/about-us.jpg);
}

.image-3 {
    background-image: url(@/assets/office-with-logo.jpg);
}

.image-4 {
    background-image: url(@/assets/about-us-3.jpg);
}

.image-5 {
    background-image: url(@/assets/about-us-2.jpg);
}

.news-container {
    background: #f6f9ff;
    padding: 2.5em;
    margin-top: 2em;
    margin-bottom: 2em;
}

.news-container p {
    text-align: justify;
}

.news-container h2 {
    color: #444;
    font-weight: normal;
    margin-bottom: 0.5em;
    font-size: 1.9rem;
}
</style>